module.exports = __webpack_public_path__ + "img/GM.3598fa83.png";